import ForecasterDateRange from '@/Enums/Forecaster/DateRange.enum';
import { DateRange } from '@mui/x-date-pickers-pro';
import moment, { Moment } from 'moment';
import { TabName } from './TabName.enum';

export const BASE_TAB_ID = 'forecaster-widget-tabs';

export const DEFAULT_DAYS_IN_RANGE = ForecasterDateRange.Week;
export const getDefaultDateRange = () => [moment(), moment().add(6, 'days')] as DateRange<Moment>;

export const TABS = Object.values(TabName).map(tabName => ({
  id: tabName,
  name: tabName,
}));

export const TAB_DAYS_RANGE = {
  [TabName.WEEKLY]: ForecasterDateRange.Week,
  [TabName.DAILY]: ForecasterDateRange.Day,
  [TabName.MONTHLY]: ForecasterDateRange.Month,
};
